module.exports = __webpack_public_path__ + "static/media/logo-gigage-white.b155bf5e.png";